import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { BsBarChartLine } from 'react-icons/bs';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

export const ConversationItem = ({ conversation, isSelected, onSelect }) => {
  return (
    <MotionBox
      whileHover={{ x: 4 }}
      p={2}
      cursor="pointer"
      borderRadius="lg"
      borderWidth="1px"
      borderColor={isSelected ? 'var(--brand-primary)' : 'transparent'}
      bg={isSelected ? 'blue.50' : 'transparent'}
      _hover={{
        bg: isSelected ? 'blue.50' : 'gray.50',
      }}
      onClick={onSelect}
      overflowX={"hidden"}
    >
      <Flex alignItems="flex-start" gap={2}>
        <Flex
          w={6}
          h={6}
          borderRadius="md"
          bg="blue.100"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          <Box as={BsBarChartLine} w={3} h={3} color="var(--brand-primary)" />
        </Flex>
        <Box flex={1} minW={0}>
          <Text fontSize="xs" noOfLines={2} mb={0.5} color={isSelected ? 'blue.700' : 'gray.800'} fontWeight={isSelected ? 'semibold' : 'normal'}>
            {conversation.title}
          </Text>
          <Text fontSize="xs" color={isSelected ? 'blue.400' : 'gray.400'}>
            {conversation.timestamp}
          </Text>
        </Box>
      </Flex>
    </MotionBox>
  );
};
